import React from 'react';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getDeviationResourceType, getDeviationUrl } from '../../../_helpers';
import { useTranslation } from 'react-i18next';
const CommentControl = ({ deviation, hasCommentedOn, className })=>{
    var _deviation_stats, _deviation_stats1, _deviation_author;
    const { t } = useTranslation();
    const { showStats } = useOverlayContext(deviation);
    var _deviation_stats_comments;
    const count = (_deviation_stats_comments = (_deviation_stats = deviation.stats) === null || _deviation_stats === void 0 ? void 0 : _deviation_stats.comments) !== null && _deviation_stats_comments !== void 0 ? _deviation_stats_comments : 0;
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(ThumbIconButton, {
        className: className,
        type: "comment",
        isEngaged: hasCommentedOn,
        showStatValue: !!showStats && !(count === 0),
        statValue: (_deviation_stats1 = deviation.stats) === null || _deviation_stats1 === void 0 ? void 0 : _deviation_stats1.comments,
        "aria-label": t('deviationview.overlay.a11y.comment', {
            count
        }),
        href: `${getDeviationUrl(deviation)}#comments`,
        biData: BiData({
            evid: 105,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
            sectionname: BiContextProvidedValue,
            sectionid: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            sectionrank: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            sort_type: BiContextProvidedValue,
            reason_shown: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        })
    });
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;

//# sourceMappingURL=CommentControl.js.map